import script from "./CoreMedical.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreMedical.vue?vue&type=script&setup=true&lang=js"

import "./CoreMedical.vue?vue&type=style&index=0&id=94d5ddc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d5ddc6"]])

export default __exports__